import { render, staticRenderFns } from "./BoutonMois.vue?vue&type=template&id=ec24c2f0&"
import script from "./BoutonMois.vue?vue&type=script&lang=js&"
export * from "./BoutonMois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports